/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const SearchIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M4.489 4.489A8.5 8.5 0 0 1 17.176 15.76l4.531 4.532a1 1 0 0 1-1.414 1.414l-4.532-4.532A8.5 8.5 0 0 1 4.49 4.49m6.01-.49a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13" clipRule="evenodd" /></svg>;
};
export default SearchIcon;